export const useDialog = (name: string, initialState: boolean = false) => {
  const status = ref(initialState)
  return {
    name,
    status,
    open: () => status.value = true,
    close: () => status.value = false,
    toggle: () => status.value = !status.value
  }
}
